<template>
  <div class="content-box">
    <div class="boxes">
      <div>
        <template v-if="systemReadListparam.total > 0">
          <!-- <div
                  class="align-center center"
                  @click="deleteReadList(item.listId)"
                  style="color: #0e6e7f"
                >
                  删除
                </div> -->
          <!-- <div
            class="box-readlist"
            v-for="(item, index) in systemReadListparam.rows"
            :key="index"
          >
            <div class="readlistitem" @click="jamp(item.listId)">
              <span>{{ item.listName }}</span
              ><span>书数：{{ item.bookCount }}本</span
              ><span>{{ item.description }}</span
              ><span>创建：{{ item.createTime }}</span>
            </div>

            <div class="layer center">
              <div class="sm-title justify-center">
                <div
                  class="align-center center"
                  style="margin-bottom: 0; margin-right: 5px; color: #0e6e7f"
                  @click="jamp(item.listId)"
                >
                  详情
                </div>


              </div>
            </div>
          </div> -->
          <div class="booklist">
            <div
              class="booklistcon"
              v-for="(item, index) in systemReadListparam.rows"
              :key="index"
              @click="jamp(item.listId, item.bookCount)"
            >
              <div class="booklistconse">
                <div class="imgcontent">

                </div>
                <div class="textcontent">
                  <div class="texttitle">{{ item.listName }}</div>
                  <div class="setitle">本书单共“{{ item.bookCount }}”本书</div>
<!--                  <div class="textline"></div>-->
                  <div class="bcontent">
                    {{ item.description }}
                  </div>
<!--                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="center" style="padding-bottom: 15px">
            <el-pagination
              background
              hide-on-single-page
              :current-page="systemReadListparam.pageNum"
              layout="prev, pager, next"
              @current-change="getNookNum"
              :page-size="systemReadListparam.pageSize"
              :total="systemReadListparam.total"
            >
            </el-pagination>
          </div>
        </template>
        <div v-else style="width: 100%"><el-empty description="暂无数据"></el-empty></div>
      </div>
      <!-- <div>
        <template>
          <div class="box-readlist">
            <div class="readlistitem">
              <span>书目</span><span>书数：</span><span></span
              ><span>创建：</span>
            </div>

            <div class="layer center">
              <div class="sm-title justify-center">
                <div
                  class="align-center center"
                  style="margin-bottom: 0; margin-right: 5px; color: #0e6e7f"
                >
                  详情
                </div>

                <div class="align-center center" style="color: #0e6e7f">
                  删除
                </div>
              </div>
            </div>
          </div>
          <div class="box-readlist">
            <div class="readlistitem">
              <span>书目</span><span>书数：</span><span></span
              ><span>创建：</span>
            </div>

            <div class="layer center">
              <div class="sm-title justify-center">
                <div
                  class="align-center center"
                  style="margin-bottom: 0; margin-right: 5px; color: #0e6e7f"
                >
                  详情
                </div>

                <div class="align-center center" style="color: #0e6e7f">
                  删除
                </div>
              </div>
            </div>
          </div>
          <div class="box-readlist">
            <div class="readlistitem">
              <span>书目</span><span>书数：</span><span></span
              ><span>创建：</span>
            </div>

            <div class="layer center">
              <div class="sm-title justify-center">
                <div
                  class="align-center center"
                  style="margin-bottom: 0; margin-right: 5px; color: #0e6e7f"
                >
                  详情
                </div>

                <div class="align-center center" style="color: #0e6e7f">
                  删除
                </div>
              </div>
            </div>
          </div>
          <div class="center">

          </div>
        </template>
      </div> -->
      <!-- <div v-if="isSystemBookList">
        <div style="text-align: right">
          <i
            class="el-icon-close"
            @click="isSystemBookList = false"
            style="cursor: pointer; font-size: 18px"
          ></i>
        </div>
        <div style="margin-top: 10px">共:{{ systemBookList.total }}本书</div>
        <div
          class="box-readlist"
          v-for="(item, index) in bookList.rows"
          :key="index"
        >
          <div class="readlistitem">
            <span>{{ item.busBook.bookName }}</span
            ><span>{{ item.busBook.categoryName }}</span
            ><span>{{ item.busBook.writer }}</span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import eventBus from "@/utils/eventBus.js"
import {
  // getPdfImages,
  // getCatalogImages,
  // getBookCatalogue,
  // getBookDetail,
  // addFavordData,
  // getFavorStatus,
  // deleteFavor,
  getReadListNew
} from "@/api/api"
// import SocialSharing from "vue-social-share"
// import EchartGx from "@/components/echart-gxnew.vue"
// import "./share/client.css"
export default {
  name: "bookList",
  components: {
    // SocialSharing,
    // EchartGx
  },
  data () {
    return {
      isSystemBookList: false,
      systemBookList: {},
      systemReadList: [],
      systemReadListparam: {
        pageNum: 1,
        pageSize: 10,
        rows: [],
        total: 0
      }
    }
  },
  mounted () {
    // this.id = this.$route.query.id
    // this.getDetail()
    // this.getFavorData()
    // this.$bus.$on("linkdialog", (type, item) => {
    //   this.linkdialog(type, item)
    // })

    this.getSystemReadList()
  },
  computed: {},
  methods: {
    jamp (id, count) {
      if (count == 0) {
        return this.$message({
          message: '该书本数量为0',
          type: 'warning'
        })
      }


      this.$router.push({ name: 'GoBooks', params: { listid: id } })
    },
    systemBookListInReadlist (id) {
      this.isSystemBookList = true
      bookListInReadlist({ listId: id }).then((d) => {
        this.systemBookList = d
      })
    },
    getSystemReadList () {
      let { pageNum, pageSize } = this.systemReadListparam
      getReadListNew({ pageNum, pageSize, isPublic: 1 }).then(d => {
        console.log(d)
        this.systemReadListparam.rows = d.rows
        this.systemReadListparam.total = d.total
      })
    },
    getNookNum (e) {
      this.systemReadListparam.pageNum = e
      this.getSystemReadList()
    }
    // addReadListBox (id) {
    //   eventBus.$emit("doChangeTwoVisible", true, id)
    // },
    // linkdialog (type, item) {
    //   if (type == 1) {
    //     // this.writerIds = item.writerId
    //     // this.copierIds = ''
    //     this.activewriter = item.writerName
    //   } else {
    //     // this.writerIds = ''
    //     // this.copierIds = item.copierId
    //     this.activewriter = item.copierName
    //   }
    //   this.linkVisible = true

    // },
    // gotomulu () {
    //   const el = this.$refs.treebox
    //   el.scrollIntoView({
    //     behavior: 'smooth'
    //   })
    // },
    // viewpdf () {
    //   const querypar = {
    //     pdfSrc: this.pdfSrc
    //   }
    //   const routeData = this.$router.resolve({
    //     //name:"viewer",
    //     path: "/pdfview",
    //     query: querypar,
    //   })
    //   if (this.pdfSrc == '') {
    //     this.$message('还没上传pdf文件')
    //   } else {
    //     window.open(routeData.href, "_blank")
    //   }
    //   // window.open(this.pdfSrc, "_blank")
    // },

  },
};
</script>

<style lang="less" scoped>
/deep/.el-input__inner {
  width: 200px;
  margin-top: 10px;
}
.booklist {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .booklistcon {
    cursor: pointer;
    margin: 20px 25px;
    width: 376px;
    height: 190px;
    padding-top: 5px;
    background: #fff;
    border-radius: 4px;
    // padding: 20px;
    .booklistconse {
      width: 100%;
      height: 100%;
      // background: rgba(255, 255, 255, 0.6);
      border-radius: 4px;
      padding: 12px;
      display: flex;
      align-items: top;
      position: relative;
      .playimg {
        img {
          width: 17px;
          height: 17px;
        }

        position: absolute;
        right: 18px;
        top: 18px;
      }
      .imgcontent {
        width: 120px;
        height: 166px;
        border-radius: 8px;
        margin-right: 20px;
        /*background: linear-gradient(
          to bottom,
          white 0%,
          white 50%,
          #EFD49B 50%,
          #F8ECCB 100%
        );*/
        background: url("/static/shudan.png") no-repeat;
        background-size: 120px 130px;
        margin-top:20px;
        img {
          width: 90px;
          height: 120px;
          margin-top:20px ;
          margin-left: 15px;
        }
      }
      .textline {
        width: 100%;
        height: 1px;
        background: #e5e5e5;
        margin: 5px 0;
      }
      .textcontent {
        flex: 1;
      }
      .texttitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #573E0D;
        letter-spacing: 0;
        line-height: 1.5;
      }
      .setitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #2B2B2B;
        letter-spacing: 0;
        line-height: 1.5;
        margin-top: 5px;
      }
      .bcontent {
        width: 100%;
        // height: 100%;
        height: 110px;
        letter-spacing: 0;
        line-height: 1.6;
        font-weight: 400;
        text-align: justify;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #2B2B2B;
        div {
          overflow: hidden;
        }

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5; /* 限制行数为5 */
        overflow: hidden;

        //   overflow: hidden;
        //   overflow-wrap: break-word;
        //   word-break: break-all; /* 对于非英文字符 */
        // }
      }
    }
  }
}
.booklistcon:hover {
  .booklistconse{
    .imgcontent {
     /* background: linear-gradient(
        to bottom,
        #F6F1E9 0%,
        #F6F1E9 50%,
        #EFD49B 50%,
        #F8ECCB 100%
      );
      transform: scale(1.1);
      transition: transform 0.3s linear;*/
    }
  }
  .playimg {
    width: 17px;
    height: 17px;
    box-shadow: 0 2px 4px 0 rgba(209, 203, 189, 0.4);
  }
  .booklistconse {
     background: #F6F1E9;
    //border: 0.5px solid rgba(44, 126, 141, 1);
    box-shadow: 0px 4px 8px 0px rgba(209, 203, 189, 0.4);
    // border-radius: 4px;
    transition: border 0.3s linear;
  }
}
.sm-title {
  font-size: 14px;

  font-weight: bold;
  color: #3366cc;

  &.justify-center {
    width: 100px;
    .align-center {
      margin-bottom: 28px;
      text-decoration: none;
      color: #3366cc;

      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
    }
    img {
      width: 18px;
      height: auto;
    }
  }
}

.box-readlist {
  display: flex;
  justify-content: space-between;
  .readlistitem {
    cursor: pointer;
    width: 80%;
    display: flex;
    span {
      font-size: 12px;
      line-height: 4;
      width: 25%;
    }
  }
}

.content-box {
  width: 100%;
  /*display: -webkit-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;*/
  //overflow: auto;
 // padding: 16px 10px;
  background: rgb(244, 240, 232);
  height: 86vh;
  justify-content: center;
  // margin: 0 auto;
  .boxes {
    //width: 1370px;
    height: 84vh;
    background-color: white;
    padding: 40px;
    border-radius: 5px;
    margin: 32px;
    margin-bottom: 0;
    overflow-y: auto;
  }
  // .lefthead {
  //   height: 64px;
  //   font-family: PingFang-SC-Bold;
  //   font-size: 16px;
  //   color: #002f38;
  //   letter-spacing: 0;
  //   text-align: center;
  //   line-height: 64px;
  //   font-weight: 700;
  //   border-bottom: 1px solid #eeeeee;
  //   span {
  //     display: inline-block;
  //     border-bottom: 2px solid #2c7e8d;
  // }
  // }
}
// .content-box .tree-list {
//   padding: 20px;
//   width: 300px;
//   position: relative;
//   background: #fff;
//   border-radius: 4px;
//   overflow: hidden;
//   min-height: 86vh;
//   img {
//     width: 100%;
//     height: auto;
//   }
//   .leftpro {
//     font-family: PingFangSC-Regular;
//     font-size: 14px;
//     color: #666666;
//     letter-spacing: 0;
//     text-align: left;
//     line-height: 2.5;
//     font-weight: 400;
//     padding: 0 10px;
//     cursor: pointer;
//   }
//   .activepro {
//     background: #2c7e8d;
//     border-radius: 4px;
//     color: #ffffff;
//   }
// }

// .content-box .select-content {
//   -webkit-box-flex: 3;
//   -ms-flex: 3;
//   flex: 3;
//   padding: 1.4rem;
//   background: rgba(255, 255, 255, 0.8);
//   border-radius: 4px;
//   min-height: 86vh;
//   background: #fff;
//   .bookname {
//     font-family: PingFang-SC-Bold;
//     font-size: 16px;
//     color: #002f38;
//     letter-spacing: 0;
//     line-height: 2;
//     font-weight: 700;
//   }
//   p,
//   ul,
//   li,
//   span {
//     span {
//       font-weight: 400;
//     }
//     font-family: PingFang-SC-Medium;
//     font-size: 14px;
//     color: #666666;
//     letter-spacing: 0;
//     line-height: 1.5;
//     font-weight: 500;
//   }
// }
// .line {
//   width: 100%;
//   height: 1px;
//   background: #eeeeee;
//   border-radius: 4px;
// }
// .el-input__inner {
//   width: 200px;
// }
</style>



// WEBPACK FOOTER //
// src/view/bookList/index.vue